import { render, staticRenderFns } from "./CFileColumn.vue?vue&type=template&id=3efb8035&scoped=true"
import script from "./CFileColumn.vue?vue&type=script&lang=js"
export * from "./CFileColumn.vue?vue&type=script&lang=js"
import style0 from "./CFileColumn.vue?vue&type=style&index=0&id=3efb8035&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb8035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efb8035')) {
      api.createRecord('3efb8035', component.options)
    } else {
      api.reload('3efb8035', component.options)
    }
    module.hot.accept("./CFileColumn.vue?vue&type=template&id=3efb8035&scoped=true", function () {
      api.rerender('3efb8035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CFileColumn.vue"
export default component.exports